const SERVER_URL =
  process.env.REACT_APP_SERVER_URL ||
  "https://cida-integration-backend-2mk6mheziq-de.a.run.app/admin/";

const IMAGE_URL = "https://storage.googleapis.com/kidsstreet-test/";
const SET_FORMAT = (amount) => {
  var formatter = new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
  });

  return formatter.format(amount);
};
const sanitizeFrontendUrl = (url) => {
  if (!url || typeof url !== "string") return "https://www.thecida.com";
  const trimmed = url.trim().replace(/\/+$/, "");
  if (
    trimmed.includes("run.app") ||
    trimmed.includes("localhost") ||
    !trimmed.startsWith("http")
  ) {
    return "https://www.thecida.com";
  }
  return trimmed;
};

const sanitizeAdminUrl = (url) => {
  if (!url || typeof url !== "string") return "https://admin.thecida.com";
  const trimmed = url.trim().replace(/\/+$/, "");
  if (
    trimmed.includes("run.app") ||
    trimmed.includes("localhost") ||
    !trimmed.startsWith("http")
  ) {
    return "https://admin.thecida.com";
  }
  return trimmed;
};

const FRONTEND_URL = sanitizeFrontendUrl(process.env.REACT_APP_FRONTEND_URL);
const ADMIN_URL = sanitizeAdminUrl(process.env.REACT_APP_ADMIN_URL);

module.exports = {
  SERVER_URL,
  IMAGE_URL,
  SET_FORMAT,
  FRONTEND_URL,
  ADMIN_URL,
};
